export default __webpack_public_path__ + "static/media/shortlisted.8eba0dad.svg";